import { render } from "./AppWrap.vue?vue&type=template&id=4f48dc1e"
import script from "./AppWrap.vue?vue&type=script&lang=js"
export * from "./AppWrap.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__